import { Form, useFormikContext } from 'formik'
import { useState } from 'react'
import { useHistory } from 'react-router'
import { isEmpty, sortBy } from 'lodash'
import Fuse from 'fuse.js'
import { useSelector } from 'react-redux'

import SearchBox from 'components/SearchBox'
import Modal from 'components/Modal'
import MenusDrawerCheckboxTree from 'components/Item/Form/Details/MenusDrawerCheckboxTree'

import { getRevenueCenters } from 'store/RevenueCenters/selector'
import { getRevenueCentersWithMenus } from 'utils/menusDrawer/getRevenueCentersWithMenus'
import { getSelectedRevenueCentersUuids } from 'utils/menusDrawer/getSelectedRevenueCentersUuids'

const Menus = ({ setFormStep, isLoading }) => {
  const [searchQuery, setSearchQuery] = useState('')

  const history = useHistory()
  const { values, setFieldValue } = useFormikContext()

  const allMenus = useSelector((state) => state?.menus?.all)
  const allRevenueCenters = useSelector(getRevenueCenters)

  // revenueCentersWithMenus return revenue centers name and uuid and
  // menus assigned to them by standId
  const revenueCentersWithMenus = getRevenueCentersWithMenus(
    allMenus,
    allRevenueCenters
  )

  const fuse = new Fuse(revenueCentersWithMenus, {
    keys: ['name', 'menus.name'],
    threshold: 0.3,
    includeMatches: true,
  })

  const filteredRevenueCentersAndMenus = isEmpty(searchQuery)
    ? revenueCentersWithMenus
    : fuse.search(searchQuery).map((item) => item.item)

  const filteredRevenueCentersAndMenusSortedAlphabetically = sortBy(
    filteredRevenueCentersAndMenus,
    'name'
  )

  const selectedRevenueCentersUuids = getSelectedRevenueCentersUuids(
    filteredRevenueCentersAndMenusSortedAlphabetically,
    values?.menuUuids
  )

  const allSelectedRevenueCentersAndMenusUuids = [
    ...values?.menuUuids,
    ...selectedRevenueCentersUuids,
  ]

  const [
    selectedRevenueCentersAndMenusUuids,
    setSelectedRevenueCentersAndMenusUuids,
  ] = useState(allSelectedRevenueCentersAndMenusUuids ?? [])

  const onCloseModal = () => {
    history.push({ state: { itemUuid: null } })
  }
  const onClickReturn = () => {
    setFormStep('itemsForm')
  }

  const handleClickSave = () => {
    const menusToSend = selectedRevenueCentersAndMenusUuids.filter(
      (uuid) => !uuid.startsWith('revenue-center-')
    )

    setFieldValue('menuUuids', menusToSend)
    setFormStep('itemsForm')
  }

  return (
    <Modal
      title="Menus"
      isReturnIcon
      onClose={onCloseModal}
      onClickReturn={onClickReturn}
      className="-narrow"
      isLoading={isLoading}
      onRequestClose={onCloseModal}
    >
      <div className="modal-body">
        <Form>
          <div className="item-settings">
            <div className="item-settings__section">
              <SearchBox
                dataCy="menu-search-box"
                value={searchQuery}
                onChange={setSearchQuery}
                placeholder="Search..."
              />
            </div>
            <div className="item-settings__section">
              <MenusDrawerCheckboxTree
                selectedRevenueCentersAndMenusUuids={
                  selectedRevenueCentersAndMenusUuids
                }
                setSelectedRevenueCentersAndMenusUuids={
                  setSelectedRevenueCentersAndMenusUuids
                }
                revenueCentersAndMenus={
                  filteredRevenueCentersAndMenusSortedAlphabetically
                }
              />
            </div>
            <div className="btn-wrapper">
              <button
                className={'btn -update'}
                type="button"
                onClick={handleClickSave}
              >
                Save
              </button>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  )
}

export default Menus
